import { defineStore } from 'pinia';
import type { IAiAgent, ITicket, IUser } from '@rready/sdk';

export interface IAiContext {
  ticketSource: Partial<ITicket>;
  user: Partial<IUser>;
  ticket: Partial<ITicket>;
  ticketJson: string;
  fieldsJson: string;
}

export const useAiAgentStore = defineStore('aiAgent', {
  state: () => ({
    allAgents: [] as IAiAgent[],
    pageAgentsIds: [] as string[],
    contextData: {} as Record<string, Partial<IAiContext>>,
    contextReloadData: 0
  }),
  getters: {
    agents: (state) => {
      return state.allAgents ? state.allAgents : [];
    },
    contextReloadKey: (state) => {
      return state.contextReloadData;
    },
    pageAgents: (state) => {
      return state.allAgents.filter((agent) =>
        state.pageAgentsIds.includes(agent.id)
      );
    }
  },
  actions: {
    resetContext() {
      this.contextData = {};
    },
    provideAgents(agents: IAiAgent[]) {
      this.allAgents = agents;
    },
    setPageAgentIds(agentIds: string[]) {
      this.pageAgentsIds = agentIds;
    },
    provideContext(context: Partial<IAiContext>, id: string): void {
      this.contextData[id] = context;
    },
    getAgent(agentId: string): IAiAgent | undefined {
      return this.allAgents.find((it) => it.id === agentId);
    },
    getContext(id: string): Partial<IAiContext> {
      return this.contextData[id];
    },
    contextUpdated() {
      this.contextReloadData += 1;
    }
  }
});
